import { apiClient } from '../../../app/api/apiClient';
import type {
  CreateTenantDomainInput,
  TenantDomain,
  UpdateTenantDomainStateInput,
} from '../types/tenant-domain.types';

interface TenantDomainEnvelope {
  success: boolean;
  domain: TenantDomain;
}

interface TenantDomainsEnvelope {
  success: boolean;
  domains: TenantDomain[];
}

export async function getTenantDomains(
  tenantId: number | string,
): Promise<TenantDomain[]> {
  const response = await apiClient.get(
    `/api/super-admin/tenants/${tenantId}/domains`,
  );

  return (response.data as TenantDomainsEnvelope).domains;
}

export async function createTenantDomain(
  tenantId: number | string,
  input: CreateTenantDomainInput,
): Promise<TenantDomain> {
  const response = await apiClient.post(
    `/api/super-admin/tenants/${tenantId}/domains`,
    input,
  );

  return (response.data as TenantDomainEnvelope).domain;
}

export async function updateTenantDomain(
  tenantId: number | string,
  domainId: number | string,
  input: UpdateTenantDomainStateInput,
): Promise<TenantDomain> {
  const response = await apiClient.patch(
    `/api/super-admin/tenants/${tenantId}/domains/${domainId}`,
    input,
  );

  return (response.data as TenantDomainEnvelope).domain;
}
